const SvgAIandMl2 = (props) => (
  <>
    <path d="M16 16v160h160V16H16Zm112 112H64V64h64v64Z" fill={props.p20} />
    <circle cx={80} cy={80} r={1} fill="#001d6c" />
    <circle cx={96} cy={80} r={1} fill="#001d6c" />
    <circle cx={112} cy={80} r={1} fill="#001d6c" />
    <circle cx={80} cy={96} r={1} fill="#001d6c" />
    <circle cx={96} cy={96} r={1} fill="#001d6c" />
    <circle cx={112} cy={96} r={1} fill="#001d6c" />
    <circle cx={80} cy={112} r={1} fill="#001d6c" />
    <circle cx={96} cy={112} r={1} fill="#001d6c" />
    <circle cx={112} cy={112} r={1} fill="#001d6c" />
  </>
);

export default SvgAIandMl2;
